<!--
 * @Author: lan.h
 * @Date: 2022-02-21 17:35:45
 * @LastEditors: lan.h
 * @LastEditTime: 2022-04-11 10:59:48
 * @Description: 优质报告
-->
<template>
  <div class="report" v-if="list.length > 0">
    <div class="mode-title">
      <span class="title-p">优质报告</span>
      <a v-if="isMore" class="more" @click="toReportList">查看更多</a>
    </div>
    <div v-for="item, index in list" :key="index">
      <div class="report-content">
        <div class="img" @click="toReport(item)"><img :src="item.logoPath | logo_show"></div>
        <div class="right">
          <h1 class="over-p2" @click="toReport(item)">{{item.title}}</h1>
          <p>
            <span>{{item.price && item.price > 0 ? ('￥' + item.price) : '免费'}}</span>
            <span>{{item.srcAuthor}}</span>
          </p>
        </div>
      </div>
      <div class="report-desc" v-if="item.summary">
        <div class="over-p6">{{item.summary}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getQualityReportList } from '../../service'

export default {
  props: {
    limit: {
      // 显示的报告的数量
      default: 1
    },
    isMore: {
      default: true
    },
    pageType: {
      default: ''    //1首页 2文章详情
    }
  },
  data() {
    return {
      list: [],
      loading: false
    }
  },
  created() {
    this.getList()
  },
  methods: {
    toReportList() {
      const href = this.$store.state.index_path + '/reportingDetail'
      window.open(href, '_blank')
      if(this.pageType == '1'){
        _czc.push(['_trackEvent', '首页(新)', '右侧优质报(查看更多)', '点击量'])
      }
      else if(this.pageType == '2'){
        _czc.push(['_trackEvent', '文章详细页(新)', '右侧(优质报告更多)', '点击量'])
      }
    },
    async getList() {
      this.loading = true
      let res = await getQualityReportList( {
        limit: this.limit
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.code == 0) {
        this.$set(this.$data, 'list', res.data)
        this.loading = false
      } else {
        this.$Message.error(res.msg)
      }
    },
    toReport(a) {
      const href = this.$store.state.index_path + '/reportDetail/' + a.uid
      window.open(href, '_blank')
      if(this.pageType == '1'){
        _czc.push(['_trackEvent', '首页(新)', '右侧优质报告(报告标题/图片)', '点击量'])
      }
      else if(this.pageType == '2'){
        _czc.push(['_trackEvent', '文章详细页(新)', '右侧(优质报告)', '点击量'])
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
.report
  .more
    font-size 14px
    font-weight 500
    &:hover 
      color #FF4800
  &-content
    margin-top 20px
    display flex
    .img
      width 159px
      height 100px
      overflow hidden
      cursor pointer
      img
        width 159px
        height 100px
        &:hover
          transform scale(1.1)
          transition all 0.6s ease 0s
    .right
      margin-left 10px
      position relative
      flex 1
      h1 
        font-size 14px
        font-weight 500
        color #333333
        line-height 18px
        cursor pointer
        &:hover
          color #FA5A00
          transition all 0.5s
      p 
        position absolute
        bottom 0
        left 0
        font-size 14px
        font-weight 500
        width 100%
        span:nth-child(1)
          color #FFC069
        span:nth-child(2)
          color #999
          float right
  &-desc
    margin-top 25px
    padding 12px 14px
    background #F8F9FA
    font-size 12px
    font-weight 500
    color #787878
    line-height 18px
    position relative 
    >div
      overflow hidden
    &::before
      position absolute 
      content '' 
      width 0
      height 0
      border-left 14px solid transparent
      border-right 14px solid transparent
      border-bottom 14px solid #F8F9FA
      left 17px 
      top -14px
</style>